/* «Сделать кружок» с итога «Создать кавер»: выбранный вариант уходит в «Говорящий кружок» («Кружок из аудио») новым файлом
   (voice-result-entry.ts). Перед передачей заново сверяются владелец (GET /app/me) и заказ (GET /app/orders/{id}: готов, итог доступен, та же
   ревизия — engine-kit/result-handoff freshResult); файл — уже загруженный Blob того же заказа и ревизии (плеер итога) или авторизованная
   выгрузка сервера. Любая неудача — исключение: ничего не передано. */
import { endpoints } from '../../api';
import type { SpeechOrder } from '../../api/speech';
import { freshResult } from '../studio/engine-kit/result-handoff';
import { stageVoiceResult } from '../voice/voice-result-entry';

export async function transferCoverResult(o: { ownerId: number | undefined; order: SpeechOrder; index: number; blob?: Blob | null }): Promise<void> {
  const { owner, order } = await freshResult({ ownerId: o.ownerId, order: o.order });
  const asset = order.result?.assets.find(item => item.index === o.index && item.mime.startsWith('audio/'));
  if (!asset) throw new Error('source_changed');
  const blob = o.blob ?? (await endpoints.speech.result(order, asset.index));
  if (!blob.size || !blob.type.startsWith('audio/')) throw new Error('invalid_result');
  stageVoiceResult({
    owner,
    orderId: order.id,
    revision: order.result_revision,
    index: asset.index,
    file: new File([blob], asset.file_name || 'steos-cover.mp3', { type: blob.type }),
    use: 'audio',
  });
}
